import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const Services = ({ btn }) => {
  const servicesInfo = (
    <>
      <p>
        The <strong>Services Market Platform</strong> is a marketplace where users can find <strong>service provider companies</strong> and <strong>individual contractors</strong> for a wide range of services. It includes <strong>Business-to-Business (B2B)</strong> connectivity and <strong>Business-to-Consumer (B2C)</strong> connectivity.
      </p>
      <p>
        On this platform, users can search for desired and required services and connect with providers who offer services on a <strong>contract, hourly, or daily basis</strong>. These services may include <strong>technical, professional, maintenance,</strong> or <strong>personal support services</strong>.
      </p>
      <p>
        The <strong>Services Market Platform</strong> makes it easy to <strong>compare service providers, choose flexible service options,</strong> and hire the right expertise according to user needs.
      </p>
           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Services</strong>
</a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + full services info */}
          <CardNav Header="Services Market" myid={1} myinfo={servicesInfo} />

          {/* BoxData for Services */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Services Providers"
              Butonn={btn}
              imgg={images.Services}
              url="/service-integrate"
              link="/find-services"
              ms="nineteen-element"
              buy="nineteen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Services;
